module.exports = __webpack_public_path__ + "static/media/welcomeSubAccount.0a8597bc.png";